type WidgetEventName =
  | 'widgetTriggered'
  | 'screeningStarted'
  | 'screeningCompleted'
  | 'appointmentSubmitted';

export const emitWidgetEvent = (name: WidgetEventName): void => {
  window.dispatchEvent(new CustomEvent(`myclinically:${name}`));
};
